import Alert from "@mui/material/Alert";
import { UploadFile } from "@mui/icons-material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { CreateCampaignFileData } from "../../../types/campaign";
import { ButtonFile } from "../../ButtonFile";

export function File() {
  const formik = useFormikContext<CreateCampaignFileData>();

  return (
    <Stack spacing={4}>
      <Typography color="primary">Arquivo</Typography>
      <Alert variant="filled" severity="warning">
        O arquivo não pode conter mais que 10MB
      </Alert>
      <ButtonFile
        accept={[
          ".csv",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ]}
        icon={<UploadFile />}
        label={formik.values.file?.name}
        onChange={(file) => formik.setFieldValue("file", file)}
      />
    </Stack>
  );
}
